import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/team.json";
import { hostLanguageDetector } from "./detector";

// English is bundled inline so the fallback path resolves with zero
// latency on first paint. Every other locale is fetched on demand via
// dynamic import in `I18nLanguageBridge` — Vite code-splits each
// `./locales/<lng>/team.json` into its own chunk.
void i18n
  .use(hostLanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en } },
    fallbackLng: "en",
    // Without this i18next reformats hyphenated codes (`sr-latn` ->
    // `sr-Latn`) and then can't find our bundle because we ship the
    // file under the lowercase directory name. Lowercase across the
    // board matches both the presenter's locale codes verbatim and
    // our on-disk layout.
    lowerCaseLng: true,
    // Mirrors the presenter's locale set verbatim
    // (`stpancras-presenter-app/src/utils/language/index.js`). Includes
    // the regional/script-suffixed `sr-latn` / `sr-cyrl` and the
    // non-ISO codes the presenter uses (`kr`, `no`, `se`, `br`).
    supportedLngs: [
      "en",
      "vi",
      "es",
      "br",
      "pt",
      "fr",
      "de",
      "id",
      "it",
      "tr",
      "ja",
      "nl",
      "ru",
      "pl",
      "da",
      "zh",
      "sl",
      "si",
      "lv",
      "cs",
      "kr",
      "no",
      "se",
      "el",
      "lt",
      "hr",
      "is",
      "bg",
      "ro",
      "sk",
      "hu",
      "sq",
      "sr-latn",
      "sr-cyrl",
      "bs",
      "et",
      "uk",
      "mk",
      "fi",
    ],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
